import AdvertListPage from '@/pages/advert/list'
import HotCityPage from '@/pages/advert/hot-city'
import RecommendRoomPage from '@/pages/advert/recommend-room'
import ArticleListPage from "@/pages/advert/article-list"
import ArticleEditPage from "@/pages/advert/article-edit"
import VideoList from "@/pages/advert/video-list"
import RoomSort from "@/pages/advert/roomSort"

// 广告列表
export const advertList = {
  path: 'advert/list',
  component: AdvertListPage
}

// 热门城市
export const hotCity = {
  path: 'advert/hotCity',
  component: HotCityPage
}

//精选、推荐房源
export const recommendRoom = {
  path: 'advert/recommendRoom',
  component: RecommendRoomPage
}

// 文章列表
export const articleList = {
  path: 'advert/articleList',
  component: ArticleListPage
}

// 文章编辑
export const articleEdit = {
  path: 'advert/articleEdit',
  component: ArticleEditPage
}

// 视频列表
export const videoList = {
  path: 'advert/videoList',
  component: VideoList
}
// 房间排序
export const roomSort = {
  path: 'advert/roomSort',
  component: RoomSort
}



// WEBPACK FOOTER //
// ./src/router/advert.js